import React from 'react';
import { agentStates } from '../../data/agentStates';
export function StateLegend({
  className = '',
  hints = false
}: {
  className?: string;
  hints?: boolean;
}) {
  return <ul className={`flex flex-wrap items-center gap-x-4 gap-y-1 ${className}`} data-id="element-175" data-mp="1hgo7vnn5z557">
      {agentStates.map(s => <li key={s.key} className="flex items-center gap-1.5 text-[11px] text-muted" data-id="element-176" data-mp="1m74othq718wb">
          <span className={`h-2 w-2 rounded-sm ${s.className}`} aria-hidden data-id="element-177" data-mp="1r6hj2nje9i8x" />
          <span className="font-medium text-ink" data-id="element-178" data-mp="1r8lk8xpws35i">{s.label}</span>
          {hints && <span className="text-subtle" data-id="element-179" data-mp="1w40vrj0g1myr">{s.hint}</span>}
        </li>)}
    </ul>;
}